import React, { lazy, FC } from 'react';
import { UserAppTransaction } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities';
import { SecureRoute, EligibleRoute } from '../../../packages/iam/src/components';
import { useNotificationsAuthorizationsList } from '../../../packages/authorizations/src';
import { AuthorizationProvider } from '../../../packages/authorizations/src/contexts/Authorization/AuthorizationProvider';

const AuthorizationDetailsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "AuthorizationDetailsPageComponent" */ '../../../packages/authorizations/src/pages/AuthorizationDetailsPage'
    ),
);

const WrappedAuthorizationsDetailsPage: FC<{ pageConfig: any }> = ({ pageConfig }) => {
  const authorizationsList = useNotificationsAuthorizationsList();
  return (
    <SecureRoute requiredEntitlements={UserAppTransaction.PendingAuthorizationsList}>
      <EligibleRoute>
        <AuthorizationProvider authorizationsList={authorizationsList}>
          <AuthorizationDetailsPage pageConfig={pageConfig} />
        </AuthorizationProvider>
      </EligibleRoute>
    </SecureRoute>
  );
};

export { WrappedAuthorizationsDetailsPage };
